import { api } from "./axios";
import { trackPlayback, untrackPlayback } from "../lib/stopBeacon";
import type { PlaybackFile } from "../types";

export async function searchRecordings(args: {
  device_id: number;
  channel: number;
  start: string;
  end: string;
  stream?: "Main" | "Extra1";
}): Promise<{ files: PlaybackFile[] }> {
  const r = await api.post("/playback/search", { ...args, stream: args.stream || "Main" });
  return r.data;
}

export interface PlaybackStartResult {
  playback_id: string;
  stream_name: string;
  ws_url: string;
  // Velocidad EFECTIVA que el backend configuro en el DVR (1 = tiempo real). Puede ser
  // menor a la pedida si la reproduccion rapida esta deshabilitada en el servidor o el
  // equipo no la soporta (transporte SDK): el cliente NO debe acelerar el <video> por
  // encima de este valor, porque el stream llega a tiempo real y se congelaria.
  speed?: number;
}

export async function startPlayback(args: {
  device_id: number;
  channel: number;
  start: string;
  end: string;
  // Velocidad pedida al DVR (1, 2, 4, 8). >1 = el DVR entrega la grabacion N veces mas
  // rapido (2x: todos los cuadros; 4x/8x: solo cuadros clave).
  speed?: number;
  transcode?: boolean;
}): Promise<PlaybackStartResult> {
  const r = await api.post("/playback/start", args);
  const data = r.data as PlaybackStartResult;
  trackPlayback(data.playback_id);
  return data;
}

export async function stopPlayback(playback_id: string) {
  // untrack recien tras confirmar el stop (mismo criterio que stopStream).
  await api.post("/playback/stop", { playback_id, action: "stop" });
  untrackPlayback(playback_id);
}

// Lista de dias (YYYY-MM-DD) con al menos una grabacion en el rango. El frontend
// la usa para pintar los puntos verdes del calendario.
export async function availableDays(args: {
  device_id: number;
  channel: number;
  start: string;
  end: string;
  stream?: "Main" | "Extra1";
}): Promise<{ days: string[] }> {
  const r = await api.post("/playback/available-days", {
    ...args,
    stream: args.stream || "Main",
  });
  return r.data;
}
